import { render } from "./LiniiDocumenteView.vue?vue&type=template&id=3080f9f9&scoped=true&ts=true"
import script from "./LiniiDocumenteView.vue?vue&type=script&lang=ts"
export * from "./LiniiDocumenteView.vue?vue&type=script&lang=ts"

import "./LiniiDocumenteView.vue?vue&type=style&index=0&id=3080f9f9&scoped=true&lang=css"
import "./LiniiDocumenteView.vue?vue&type=style&index=1&id=3080f9f9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3080f9f9"]])

export default __exports__